import { JSX } from "react";

import AvatarCard from "@/components/cards/AvatarCard.tsx";

import { ROUTES } from "@/config/routes.ts";

const PersonsSinglePage = (): JSX.Element => {
  return (
    <section className={"bg-surface-bright mt-14 rounded-7.5 px-8 py-6 max-lg:mt-0"}>
      <h1 className={"text-[2rem]/normal font-semibold max-lg:text-2xl"}>Режиссеры</h1>
      <div
        className={
          "mt-5 grid grid-cols-9 gap-x-10 gap-y-5 max-3xl:grid-cols-8 max-2xl:grid-cols-6 max-xl:grid-cols-5 max-lg:grid-cols-4 max-lg:gap-x-4 max-lg:gap-y-4 max-md:grid-cols-3 max-sm:grid-cols-2"
        }
      >
        {new Array(30).fill("https://cdn.splay.uz/media/persons/gandzha-karuppu.jpg").map((item, index) => (
          <AvatarCard
            key={index}
            type={"round-1"}
            link={ROUTES.PERSON_DETAILS.replace(":id", index.toString())}
            imageSrc={item}
            name={"name"}
          />
        ))}
      </div>
    </section>
  );
};

export default PersonsSinglePage;
